import { find, register } from '../../../../Javascript/Sysmex/Utils'

const FormFieldDescription = el => {
  const componentPrefix = 'sysmexAtomFormFieldDescription_'
  const opener = find(`.${componentPrefix}opener`, el)
  opener.addEventListener('click', () => {
    el.classList.toggle(`${componentPrefix}active`)
  })
}

register('FormFieldDescription', FormFieldDescription)
